<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">
          <v-icon left>mdi-create</v-icon>Ajouter nouvelle diplome
        </v-btn>
      </template>
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-card-title>
          <span class="headline">Diplome</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-form ref="form">
                <v-col cols="12">
                  <v-text-field
                    label="Titre"
                    hint="Titre du diplome"
                    color="secondary"
                    outlined
                    :error-messages="diplomaNameErrors"
                    @input="$v.diploma.diplomaName.$touch()"
                    @blur="$v.diploma.diplomaName.$touch()"
                    v-model="diploma.diplomaName"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    color="secondary"
                    label="Institut"
                    placeholder="Où vous avez eu cette diplome"
                    hint="exemple: Institut &#34;XXXXX&#34;"
                    outlined
                    :error-messages="instituteErrors"
                    @input="$v.diploma.institute.$touch()"
                    @blur="$v.diploma.institute.$touch()"
                    v-model="diploma.institute"
                  />
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="diploma.file"
                    color="secondary"
                    :error-messages="fileErrors"
                    @input="$v.diploma.file.$touch()"
                    @blur="$v.diploma.file.$touch()"
                    placeholder="fichier de justification de diplome"
                    label="Justificatif du diplome"
                    prepend-icon="mdi-paperclip"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small dark label color="green">{{ text }}</v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-form>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Fermer</v-btn
          >
          <v-btn color="blue darken-1" text @click="save">Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    diploma: {
      diplomaName: { required },
      institute: { required },
      file: { required },
    },
  },
  computed: {
    ...mapGetters({ user: "user", loading: "loading" }),
    validate() {
      return (
        this.diploma.diplomaName != "" &&
        this.diploma.institute != "" &&
        this.diploma.file != null
      );
    },
    instituteErrors() {
      const errors = [];
      if (!this.$v.diploma.institute.$dirty) return errors;
      !this.$v.diploma.institute.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    diplomaNameErrors() {
      const errors = [];
      if (!this.$v.diploma.diplomaName.$dirty) return errors;
      !this.$v.diploma.diplomaName.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.diploma.file.$dirty) return errors;
      !this.$v.diploma.file.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
  },
  data: () => ({
    diploma: { diplomaName: "", institute: "", file: null },
    dialog: false,
  }),
  watch: {
    dialog() {
      this.$refs.form.reset();
    },
  },
  methods: {
    ...mapActions(["saveDiploma", "setMessageSuccess", "clearMessageSuccess"]),
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveDiploma({ ...this.diploma, type: this.user.type });
        this.dialog = false;
      }
    },
  },
};
</script>
